/**
 * Transforms an array of `IGQLPostProductUnitNode` objects into an array of `CatchGearItem` objects.
 *
 * @param usedGearFromPost - An array of `IGQLPostProductUnitNode` objects representing the gear used in the post.
 * @returns An array of `CatchGearItem` objects with the necessary properties extracted and formatted.
 */
import { IGQLPostProductUnitNode } from '../../../interfaces/post';
import { CatchGearItem } from '../types/CatchGearItem';

export const getCatchGearItems = (usedGearFromPost: IGQLPostProductUnitNode[]): CatchGearItem[] => {
  return usedGearFromPost.map(gear => {
    const { product, image } = gear;
    const { displayName, brand } = product;
    return {
      product: {
        _id: product._id,
        brand: {
          name: brand.name,
        },
        displayName: displayName,
        image: image,
      },
    };
  });
};
